import _groupBy from 'lodash.groupby';

import CREDIT_TYPE from '../constants/creditType';

export default function getBucket(
balances,
modifier = CREDIT_TYPE.RECURRING)
{
  const groupedBalances = _groupBy(balances, (balance) => `${balance.product || ''}${balance.teamId || ''}`);

  return Object.keys(groupedBalances).map((key) => {
    const creditBalance = groupedBalances[key].find((b) => b.type === 'WORKSPACE|CREDITS');
    const topUpCreditBalance = groupedBalances[key].find((b) => b.type === 'WORKSPACE|TOPUP_CREDITS');
    const bufferBalance = groupedBalances[key].find((b) => b.type === 'WORKSPACE|BUFFER_CREDITS');

    const { teamId, teamName, product } = creditBalance || topUpCreditBalance || {};

    const { value = 0 } = modifier === CREDIT_TYPE.TOPUP ?
    topUpCreditBalance || {} :
    creditBalance || {};

    const valueLabel = value === Infinity ? 'Unlimited' : value;

    return {
      credit: creditBalance ? Number(creditBalance.value) : 0,
      suffix: `${valueLabel} Credits`,
      label: product || teamName.toUpperCase(),
      topUpCredit: topUpCreditBalance ? Number(topUpCreditBalance.value) : 0,
      bufferRemaining: bufferBalance ? Number(bufferBalance.value) : 0,
      ...(key === 'WORKSPACE' ? {
        product: 'WORKSPACE'
      } : {
        teamId,
        teamName
      })
    };
  });
}